import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchProviderImportations = (params = 'pending') => apiActionCreator({
  'endpoint': `/orders/dealers/on_order${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PROVIDERS_IMPORTATIONS,
    ActionTypes.FETCHED_PROVIDERS_IMPORTATIONS,
    [
      ActionTypes.FETCHED_PROVIDERS_IMPORTATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateProviderImportations = (data, payload) => apiActionCreator({
  'endpoint': '/orders/dealers/on_order',
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_PROVIDERS_IMPORTATIONS,
    [
      {
        'type': ActionTypes.UPDATED_PROVIDERS_IMPORTATIONS,
        'payload': payload,
      },
      MessageActions.addMessageBoxInfo('Se ha actualizado exitosamente'),
    ],
    [
      ActionTypes.UPDATED_PROVIDERS_IMPORTATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const downloadInTransitImportsReport = (filters) => apiActionCreator({
  'endpoint': '/orders/dealers/on_order',
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_REQUEST,
    ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_SUCCESS,
    [
      ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': filters,
});

export const updateInvoicePortArrivalDate = (invoice, arrivalDate, status) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/orders/providers/in-transit/${invoice}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_REQUEST,
        () => {
          dispatch(fetchProviderImportations({'status': 'pending'}));
          return {'type': ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_SUCCESS};
        },
        [
          ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': {arrivalDate},
    })
  );
};

export const getPortArrivalAuditLog = (invoice) => apiActionCreator({
  'endpoint': `/orders/providers/in-transit/${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_REQUEST,
    ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_SUCCESS,
    [
      ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeProvidersImportationsListPage = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_IMPORTATIONS_LIST_PAGE,
  'payload': value,
});

export const changeProvidersImportationsListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_IMPORTATIONS_LIST_PAGE_SIZE,
  'payload': value,
});

export const editInTransitSelectedInvoice = (value) => ({
  'type': ActionTypes.EDIT_IN_TRANSIT_SELECTED_INVOICE,
  'payload': value,
});

export const clearInTransitImportsFilters = () => ({
  'type': ActionTypes.CLEAR_IN_TRANSIT_IMPORTS_FILTERS,
});

export const editInTransitImportsFilter = (filter, value) => ({
  'type': ActionTypes.EDIT_IN_TRANSIT_IMPORTS_FILTER,
  'payload': {filter, value},
});
